import { useCanRead } from '@artic/api-client';
import { useFeatureFlag } from '@artic/ui/feature-flags';
import { PartnerApiIcon } from '@artic/ui/icons/nav';
import { getPartnerApiManageUrl } from '@artic/ui/lib/environment';
import { Button, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/**
 * The sidebar footer's link to the Partner API dashboard on the realtime
 * service, shown only while the partner's `partner_api` flag is on and the
 * person can read the Partner API permission section. Realtime enforces the
 * permission on the dashboard itself. Neo and Dashboards render the same link
 * (`@artic/ui/partner-api-nav-link`).
 *
 * A component of its own so it can be tested: the footer's `SidebarSection`
 * needs the style context of saas-ui's `Sidebar`.
 */
export const PartnerApiLink = ({ isOpen }: { isOpen: boolean }) => {
  const { t } = useTranslation('translation');
  const enabled = useFeatureFlag('partner_api');
  const canRead = useCanRead('partner_api');
  if (!enabled || !canRead) return null;

  const href = getPartnerApiManageUrl();

  if (!isOpen) {
    return (
      <IconButton
        as="a"
        href={href}
        icon={<PartnerApiIcon aria-hidden={true} />}
        aria-label={t('partner_api')}
        mt="4"
      />
    );
  }

  return (
    <Button
      as="a"
      href={href}
      variant="ghost"
      mt="4"
      leftIcon={<PartnerApiIcon aria-hidden={true} />}
    >
      {t('partner_api')}
    </Button>
  );
};
